import { Field } from 'formik';
import { ForwardedRef, forwardRef, useMemo } from 'react';
import { Radio, RadioProps } from '@hyperflake/react-ui-library/forms';

interface FormikRadioProps extends RadioProps {}

const FormikRadio = forwardRef((props: FormikRadioProps, ref: ForwardedRef<HTMLInputElement>) => {
    const { name, id, ...rest } = props;

    const idOrName = useMemo(() => {
        return id || name;
    }, [id, name]);

    return <Field type="radio" {...rest} ref={ref} id={idOrName} name={name} as={Radio} />;
});

export default FormikRadio;
